import GlobalStyles from '@mui/joy/GlobalStyles';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
// import Button from '@mui/joy/Button';
// import Card from '@mui/joy/Card';
// import Chip from '@mui/joy/Chip';
import Divider from '@mui/joy/Divider';
import IconButton from '@mui/joy/IconButton';
// import Input from '@mui/joy/Input';
// import LinearProgress from '@mui/joy/LinearProgress';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
// import Stack from '@mui/joy/Stack';
// import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
// import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
// import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import ProfileIcon from '@mui/icons-material/Work';
import SupportRoundedIcon from '@mui/icons-material/SupportRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
// import BrightnessAutoRoundedIcon from '@mui/icons-material/BrightnessAutoRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { closeSidebar, getCdnFileUrl } from '../utils';
import { ColorSchemeToggle } from './auth/AuthLayout';
// import src from '@emotion/styled';
import { Link, NavLink } from 'react-router';
import logo from '../assets/images/logo.svg';
import { AUTH_TOKEN_NAME } from '../constants';
import { googleLogout } from '@react-oauth/google';
import { useState } from 'react';
import ClientCredits from './ClientCredits';
import useTeamPermissions from '../hooks/useTeamPermissions';
// import { useFeedback } from './feedback/Service';

const CLIENT_MENU_ITEMS = [
  { name: 'Dashboard', icon: <DashboardRoundedIcon />, path: '/dashboard' },
  { name: 'Settings', icon: <SettingsRoundedIcon />, path: '/company', placement: 'bottom' },
  { name: 'Jobs', icon: <AssignmentRoundedIcon />, path: '/jobs', onlyAts: false, onlyNonAts: true },
  { name: 'Imported Jobs', icon: <AssignmentRoundedIcon />, path: '/jobs', onlyAts: true, onlyNonAts: false },
  { name: 'Team', icon: <GroupRoundedIcon />, path: '/team', requiresManageTeam: true, placement: 'bottom' },
];

const TALENT_MENU_ITEMS = [
  { name: 'Profile', icon: <ProfileIcon />, path: '/profile' },
  { name: 'Applications', icon: <AssignmentRoundedIcon />, path: '/applications' },
];

const ADMIN_MENU_ITEMS = [
  { name: 'Dashboard', icon: <DashboardRoundedIcon />, path: '/admin/dashboard' },
  { name: 'Users', icon: <GroupRoundedIcon />, path: '/admin/users' },
  { name: 'Companies', icon: <HomeRoundedIcon />, path: '/admin/companies' },
  { name: 'Interview Sections', icon: <AssignmentRoundedIcon />, path: '/admin/interview-sections' },
  { name: 'Positions', icon: <AssignmentRoundedIcon />, path: '/admin/positions' },
  { name: 'Evaluation Prompts', icon: <AssignmentRoundedIcon />, path: '/admin/evaluation-prompts' },
  { name: 'Tiers', icon: <AssignmentRoundedIcon />, path: '/admin/tiers' },
];

function Toggler({
  defaultExpanded = false,
  renderToggle,
  children,
}) {
  const [open, setOpen] = useState(defaultExpanded);
  return (
    <>
      {renderToggle({ open, setOpen })}
      <Box
        sx={[
          {
            display: 'grid',
            transition: '0.2s ease',
            '& > *': {
              overflow: 'hidden',
            },
          },
          open ? { gridTemplateRows: '1fr' } : { gridTemplateRows: '0fr' },
        ]}
      >
        {children}
      </Box>
    </>
  );
}

export default function Sidebar({ user }) {
  // const feedback = useFeedback();
  const permissions = useTeamPermissions(user?.client);
  console.log("Sidebar permissions", permissions, user?.client);

  const handleSignOut = () => {
    localStorage.setItem(AUTH_TOKEN_NAME, "");
    googleLogout();
    window.location.reload();
  }

  const handleSupportOpen = () => {
    // if (window.HubSpotConversations?.widget) {
    //   window.HubSpotConversations.widget.open();
    // } else {
    //   console.warn("HubSpot Conversations widget is not available");
    // }
    // feedback.alert({
    //   maxWidth: 'md',
    //   fullWidth: true,
    //   fullScreen: false,
    //   removePadding: true,
    //   clickAwayClose: true,
    //   confirmButtonText: "Close",
    //   component: (
    //     <div className="hs-form-frame" data-region="na1" data-form-id="95cd0365-3a29-4b45-bc7b-d1b163c96a02" data-portal-id="44214538"></div>
    //   )
    // });

    // open intercom support chat
    if (window.Intercom) {
      window.Intercom('show');
    } else {
      console.warn("Intercom is not available");
    }
  }

  return (
    <Sheet
      className="Sidebar"
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        transform: {
          xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
          md: 'none',
        },
        transition: 'transform 0.4s, width 0.4s',
        zIndex: 1300,
        height: '100dvh',
        width: 'var(--Sidebar-width)',
        top: 0,
        p: 2,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ':root': {
            '--Sidebar-width': '220px',
            [theme.breakpoints.up('lg')]: {
              '--Sidebar-width': '240px',
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: 'fixed',
          zIndex: 9998,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          opacity: 'var(--SideNavigation-slideIn)',
          backgroundColor: 'var(--joy-palette-background-backdrop)',
          transition: 'opacity 0.4s',
          transform: {
            xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
            lg: 'translateX(-100%)',
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', "& img": { mt: 1 } }}>
        {/* <IconButton variant="soft" color="primary" size="sm">
          <BrightnessAutoRoundedIcon />
        </IconButton> */}
        {/* <Typography level="title-lg">Acme Co.</Typography> */}
        <Link to="/">
          <img src={logo} alt="Cavalry" />
        </Link>
        <ColorSchemeToggle sx={{ ml: 'auto' }} />
      </Box>
      {/* <Input size="sm" startDecorator={<SearchRoundedIcon />} placeholder="Search" /> */}
      <Divider sx={{ my: 0 }} />
      <Box
        sx={{
          minHeight: 0,
          overflow: 'hidden auto',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <List
          size="sm"
          sx={{
            gap: 1,
            '--List-nestedInsetStart': '30px',
            '--ListItem-radius': (theme) => theme.vars.radius.sm,
          }}
        >
          {/* <ListItem>
            <ListItemButton>
              <HomeRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Home</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem> */}
          {permissions.canViewBilling && <ClientCredits />}
          {user.client && CLIENT_MENU_ITEMS
            .filter((item) => {
              // Check if item requires MANAGE_TEAM permission
              if (item.placement === "bottom")
                return false;
              if (item.requiresManageTeam) {
                return permissions.canManageTeam;
              }
              if (item.onlyAts)
                return user.client.usesATS
              if (item.onlyNonAts)
                return !user.client.usesATS
              return true;
            })
            .map((item) => (
              <ListItem
                key={item.path}
                sx={{
                  [`& > .${listItemButtonClasses.root}.active`]: {
                    fontWeight: "var(--joy-fontWeight-md)",
                    backgroundColor: "var(--variant-plainActiveBg, var(--joy-palette-neutral-plainActiveBg, var(--joy-palette-neutral-200, #DDE7EE)))",
                    "--Icon-color": "currentColor",
                  }
                }}
              >
                <ListItemButton component={NavLink} to={item.path}>
                  {item.icon}
                  <ListItemContent>
                    <Typography level="title-sm">{item.name}</Typography>
                  </ListItemContent>
                </ListItemButton>
              </ListItem>
            ))}
          {user.talent && (!user.client || user.role === "ADMIN") && TALENT_MENU_ITEMS.map((item) => (
            <ListItem
              key={item.path}
              sx={{
                [`& > .${listItemButtonClasses.root}.active`]: {
                  fontWeight: "var(--joy-fontWeight-md)",
                  backgroundColor: "var(--variant-plainActiveBg, var(--joy-palette-neutral-plainActiveBg, var(--joy-palette-neutral-200, #DDE7EE)))",
                  "--Icon-color": "currentColor",
                }
              }}
            >
              <ListItemButton component={NavLink} to={item.path}>
                {item.icon}
                <ListItemContent>
                  <Typography level="title-sm">{item.name}</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          ))}
          {/* <ListItem>
            <ListItemButton
              role="menuitem"
              component="a"
              href="/joy-ui/getting-started/templates/kanban/"
            >
              <AssignmentRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Kanban</Typography>
              </ListItemContent>
            </ListItemButton>
          {/* <ListItem>
            <ListItemButton
              role="menuitem"
              component="a"
              href="/joy-ui/getting-started/templates/order-dashboard/"
            >
              <ShoppingCartRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Orders</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem> */}
          {user.role === "ADMIN" &&
            <ListItem nested>
              <Toggler
                renderToggle={({ open, setOpen }) => (
                  <ListItemButton onClick={() => setOpen(!open)}>
                    <SettingsRoundedIcon />
                    <ListItemContent>
                      <Typography level="title-sm">Admin</Typography>
                    </ListItemContent>
                    <KeyboardArrowDownIcon
                      sx={[
                        open ? { transform: 'rotate(180deg)' } : { transform: 'none' },
                      ]}
                    />
                  </ListItemButton>
                )}
              >
                <List sx={{ gap: 0.5 }}>
                  {ADMIN_MENU_ITEMS.map((item, index) => (
                    <ListItem
                      key={item.path}
                      sx={{
                        mt: index === 0 ? 0.5 : 0,
                        [`& > .${listItemButtonClasses.root}.active`]: {
                          fontWeight: "var(--joy-fontWeight-md)",
                          backgroundColor: "var(--variant-plainActiveBg, var(--joy-palette-neutral-plainActiveBg, var(--joy-palette-neutral-200, #DDE7EE)))",
                          "--Icon-color": "currentColor",
                        }
                      }}

                    >
                      <ListItemButton component={NavLink} to={item.path}>
                        {item.name}
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Toggler>
            </ListItem>
          }
          {/* <ListItem>
            <ListItemButton
              role="menuitem"
              component="a"
              href="/joy-ui/getting-started/templates/messages/"
            >
              <QuestionAnswerRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Messages</Typography>
              </ListItemContent>
              <Chip size="sm" color="primary" variant="solid">
                4
              </Chip>
            </ListItemButton>
          </ListItem> */}
          {/* <ListItem nested>
            <Toggler
              defaultExpanded
              renderToggle={({ open, setOpen }) => (
                <ListItemButton onClick={() => setOpen(!open)}>
                  <GroupRoundedIcon />
                  <ListItemContent>
                    <Typography level="title-sm">Users</Typography>
                  </ListItemContent>
                  <KeyboardArrowDownIcon
                    sx={[
                      open ? { transform: 'rotate(180deg)' } : { transform: 'none' },
                    ]}
                  />
                </ListItemButton>
              )}
            >
              <List sx={{ gap: 0.5 }}>
                <ListItem sx={{ mt: 0.5 }}>
                  <ListItemButton selected>My profile</ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton>Create a new user</ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton>Roles & permission</ListItemButton>
                </ListItem>
              </List>
            </Toggler>
          </ListItem> */}
        </List>
        <List
          size="sm"
          sx={{
            mt: 'auto',
            flexGrow: 0,
            '--ListItem-radius': (theme) => theme.vars.radius.sm,
            '--List-gap': '8px',
            mb: 2,
          }}
        >
          {user.client && CLIENT_MENU_ITEMS.filter((item) => item.placement === "bottom").map((item) => (
            <ListItem
              key={item.path}
              sx={{
                [`& > .${listItemButtonClasses.root}.active`]: {
                  fontWeight: "var(--joy-fontWeight-md)",
                  backgroundColor: "var(--variant-plainActiveBg, var(--joy-palette-neutral-plainActiveBg, var(--joy-palette-neutral-200, #DDE7EE)))",
                  "--Icon-color": "currentColor",
                }
              }}
            >
              <ListItemButton component={NavLink} to={item.path}>
                {item.icon}
                <ListItemContent>
                  <Typography level="title-sm">{item.name}</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          ))

          }
          <ListItem>
            <ListItemButton onClick={handleSupportOpen}>
              <SupportRoundedIcon />
              Support
            </ListItemButton>
          </ListItem>
          {/* <ListItem>
            <ListItemButton>
              <SettingsRoundedIcon />
              Settings
            </ListItemButton>
          </ListItem> */}
        </List>
        {/* <Card
          invertedColors
          variant="soft"
          color="warning"
          size="sm"
          sx={{ boxShadow: 'none' }}
        >
          <Stack
            direction="row"
            sx={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            <Typography level="title-sm">Used space</Typography>
            <IconButton size="sm">
              <CloseRoundedIcon />
            </IconButton>
          </Stack>
          <Typography level="body-xs">
            Your team has used 80% of your available space. Need more?
          </Typography>
          <LinearProgress variant="outlined" value={80} determinate sx={{ my: 1 }} />
          <Button size="sm" variant="solid">
            Upgrade plan
          </Button>
        </Card> */}
      </Box>
      <Divider />
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', textDecoration: "none" }} component={Link} to="/account">
        <Avatar
          variant="outlined"
          size="sm"
          src={user.avatarUrl ? getCdnFileUrl(user.avatarUrl) : undefined}
        />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography level="title-sm" sx={{ overflow: "hidden" }}>{user.firstName} {user.lastName}</Typography>
          <Typography level="body-xs" sx={{ wordBreak: "break-all" }}>{user.email}</Typography>
        </Box>
        <IconButton size="sm" variant="plain" color="neutral" onClick={handleSignOut}>
          <LogoutRoundedIcon />
        </IconButton>
      </Box>
    </Sheet>
  );
}
